import { useState, useEffect } from 'react';
import { positionChangeQueue } from '~/editor/lib/PositionChangeQueue';
import { globalPendingRequestTracker } from '~/editor/lib/PendingRequestTracker';

const DEBOUNCE_MS = 1000;

export const usePendingPositionChanges = () => {
  const [queueCount, setQueueCount] = useState(0);
  const [pendingCount, setPendingCount] = useState(0);
  const [debouncedTotal, setDebouncedTotal] = useState(0);

  useEffect(() => {
    const unsubscribeQueue = positionChangeQueue.subscribe(setQueueCount);
    const unsubscribePending =
      globalPendingRequestTracker.subscribe(setPendingCount);

    return () => {
      unsubscribeQueue();
      unsubscribePending();
    };
  }, []);

  useEffect(() => {
    const total = queueCount + pendingCount;

    if (total === 0) {
      setDebouncedTotal(0);
      return;
    }

    const timeoutId = setTimeout(() => {
      setDebouncedTotal(total);
    }, DEBOUNCE_MS);

    return () => clearTimeout(timeoutId);
  }, [queueCount, pendingCount]);

  return debouncedTotal;
};
